/* require global playback */
import $ from 'jquery';

import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import SubscriptionBanner from 'shared/components/subscription_banner';
import ContentGatingBanner from 'shared/components/content_gating_banner'
import ContentAccessWatcher from 'shared/content_access_watcher';
import WatchSessionLimiter from 'shared/watch_session_limiter';
import KmklabsUtil from 'shared/kmklabs_util';
import AhoyEvent from 'shared/ahoy_event';
import AhoyTracker from 'shared/ahoy_tracker';
import Topic from 'shared/topic';
import { isEmptyObject, IsPremiumUser, isMobile } from 'shared/vidio_helpers';
import PreviewLoginBanner from 'components/shared/PreviewLoginBanner/PreviewLoginBanner';
import CommentVideoSection from 'shared/components/comment_video_section';
import MuxLoader from 'components/shared/MuxLoader/MuxLoader';
import VoucherActivation from 'components/shared/VoucherActivation/VoucherActivation';
import LocationAdapter from 'shared/location_adapter';
import LocalStorageAdapter from 'shared/localstorage_adapter.js';

// auth
import { ApiKey } from "commons/ApiKey";

export default class PremiumPlayerInitializer {
  static get NotEligibleForContent() { return 0; }
  static get EligibleForVideoPreview() { return 1; }
  static get EligibleForLivestreamingPreview() { return 2; }
  static get EligibleForFullContent() { return 3; }

  constructor(currentUser){
    this._currentUser = currentUser;
    this.initialPlayerTime = undefined;
    this.locationAdapter = new LocationAdapter();
  }

  initialize(){
    let contentGatingBanner = this.createContentGatingBanner();
    contentGatingBanner.init();
    if(contentGatingBanner.banner) return;
    if (KmklabsUtil.videoId() && KmklabsUtil.isPremium()){
      this.validateUserWhenVoucherCodeExists();
      this.subscribePaymentBlockerShow();
      this.subscribePaymentBlockerHide();
      if(!isMobile()){
        this.initPlayerOfferSubscription();
      }
      this.preparePlayer();
    }
  }

  validateUserWhenVoucherCodeExists() {
    const offerLoginForVoucherKey = 'next-login-offer-for-voucher';
    let expiryTime = parseInt(LocalStorageAdapter.getItem(offerLoginForVoucherKey));
    if (isNaN(expiryTime)) { expiryTime = 0; }
    const now = new Date();

    const voucherCodeURLParam = this.getVoucherCodeParam();
    if(voucherCodeURLParam && !this.currentUser && now.getTime() > expiryTime ) {
      const blockLoginRedirectDurationInMs = 5*60*1000
      const offerLoginForVoucherExpireTime = now.getTime() + blockLoginRedirectDurationInMs;
      LocalStorageAdapter.setItem(offerLoginForVoucherKey, JSON.stringify(offerLoginForVoucherExpireTime));
      const returnToParam = encodeURIComponent(this.locationAdapter.pathname+this.locationAdapter.search);
      LocationAdapter.href(`/users/login?user_return_to=${returnToParam}`);
    }
  }

  createContentGatingBanner() {
    return new ContentGatingBanner(this.currentUser);
  }

  initPlayerOfferSubscription() {
    const playerOfferDOM = this.playerOfferElement()
    const playerOfferSubscriptionBuy = playerOfferDOM?.querySelector('.js-player-offer-buy')
    
    if(playerOfferDOM && playerOfferSubscriptionBuy) {
      playerOfferSubscriptionBuy.addEventListener('click', () => this.handlePlayerOfferBuyClick())
    }
  }

  handlePlayerOfferBuyClick() {
    const isPaywallBlockerHide = document.querySelector('.watchpage-premium-banner').classList.contains('hide');

    if(isPaywallBlockerHide){
      this.handlePaymentBlockerShow(this)
      
      if(window.player.isReady()){
        window.player.tech().pause()
        this.appendCloseButton()
      }
    }
  }

  appendCloseButton() {
    const watchPremiumBanner = document.querySelector('.watchpage-premium-banner');
    
    if(watchPremiumBanner){
      const buttonClose = document.createElement('button');
      buttonClose.className = 'playback-subscription-blocker-close-button';
      buttonClose.innerHTML = '×';

      watchPremiumBanner.appendChild(buttonClose)
      buttonClose.addEventListener('click', () => this.handlePaywallBlockerCloseClick())
    }
  }

  handlePaywallBlockerCloseClick() {
    const buttonClose = document.querySelector('.playback-subscription-blocker-close-button')
    this.handlePaymentBlockerHide()
    buttonClose.remove()
  }

  subscribePaymentBlockerShow() {
    Topic.subscribe('player/paymentblocker/show', this.handlePaymentBlockerShow.bind(this));
  }

  subscribePaymentBlockerHide() {
    Topic.subscribe('player/paymentblocker/hide', this.handlePaymentBlockerHide.bind(this));
  }

  contentTypeIsVideos() {
    return document.querySelector('body').getAttribute('data-controller').includes('videos');
  }

  isNewPaywallDesktop() {
    const playerOfferButton = document.querySelector(".player-offer-buy[data-is-new-paywall-desktop='true']");
    return playerOfferButton !== null;
  }

  handlePaymentBlockerShow(data) {
    if(this.contentTypeIsVideos()){
      this.applyVoucher();

      if(this.isNewPaywallDesktop()){
        if(this.isPlayerPreviewEnded(data)){
          this.showPlayerThumbnail();
        } else {
          window.location.href = `/plans?content_id=${this.playableId}&content_type=video`;
        }
      } else {
        SubscriptionBanner.show(data);
      }
    } else {
      if(data) {
        if(this.isPlayerPreviewEnded(data)){
          this.applyVoucher();
          this.toggleBannerOrCta();
        }
      }
    }
  }

  isPlayerPreviewEnded(data) {
    if(!data) return false;

    let endSource = data.source;
    return endSource == 'preview end';
  }

  handlePaymentBlockerHide() {
    if(this.contentTypeIsVideos()){
      SubscriptionBanner.hide();
    }
  }

  preparePlayer(){
    let userIsLoggedIn = this.currentUser != null;
    let contentTypeIsVideos = this.contentTypeIsVideos();

    if (userIsLoggedIn) {
      if(contentTypeIsVideos){
        this.setPlayerStatus('videos');
      }else{
        this.removeContentPreviewStatus();
        this.setPlayerStatus('livestreamings');
      }

      return;
    }

    if(this.playableHasContentPreview()){
      SubscriptionBanner.hide();
      CommentVideoSection.disable();
    } else {
      if(!isMobile()){
        this.showPlayerThumbnail()
      }
      this.toggleBannerOrCta();
      this.hideLoader();
    }

    if (contentTypeIsVideos){
      let defaultData = {source: false, source_dash: false};
      if (window.player != undefined) {
        this.setNewSource(defaultData);
      } else {
        Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, defaultData));
      }

      if(!isMobile()){
        this.toggleBannerOrCta()
      }
    } else{
      PreviewLoginBanner.show();
    }
  }

  hideLoader() {
    let loader = document.querySelector(".player-loader");
    if (loader) { loader.style.display = 'none'; }
  }

  setNewSource(data) {
    let element = this.playerElement();

    if(element == null){
      return;
    }

    let dataSource = data.source

    element.setAttribute("data-cdn", data.cdn);

    if(dataSource == false && this.playableHasContentPreview()){
      dataSource = element.getAttribute("data-content-preview-url");
      element.setAttribute("data-preview", "true");
      element.setAttribute("data-drm-enabled", "false");
      element.setAttribute("data-vjs-clip-dash-url", "");
      element.setAttribute("data-vjs-clip-hls-url", "");
    }

    if(data.is_preview){
      element.setAttribute("data-preview", "true");
      element.setAttribute("data-preview-duration", data.preview_duration);
    }

    window.kmklabs.video.source = dataSource;
    window.kmklabs.video.source_dash = data.source_dash;

    if(dataSource == false) {
      element.setAttribute("data-vjs-clip-hls-url", "");
      element.setAttribute("data-vjs-clip-dash-url", "");
      this.hideLoader();
      return;
    }

    if(typeof dataSource == 'string'){
      element.setAttribute("data-vjs-clip-hls-url", dataSource);
    }

    if(typeof data.source_dash == 'string'){
      element.setAttribute("data-vjs-clip-dash-url", data.source_dash);
    }

    PremiumPlayerInitializer.initializePlayer(this.playerId);
  }

  playerElement(){
    if(this._playerElement != null){
      return this._playerElement;
    }

    let element = document.querySelector(`#${this.playerId}`);

    this._playerElement = element;
    return element;
  }

  get playerId(){
    return `player-data-${this.playableId}`;
  }

  playableHasContentPreview(){
    let element = this.playerElement();
    if(element == null) return false;

    return element.getAttribute('data-has-content-preview') == 'true';
  }

  static initializePlayer(playerId){
    window.player = new playback.Player(playerId, PremiumPlayerInitializer.isAdsEnabled()); // jshint ignore:line
    window.player.initialize();
    this.loadMux();
  }

  static isAdsEnabled() {
    return window.__playbackConfig.disableAds != "true";
  }

  static loadMux() {
    if (window.is_mux_loaded) {
      const playerInitTime = Date.now();
      MuxLoader.loadAndInit({
        configs: window.mux_configs,
        player_init_time: playerInitTime
      });
    }
  }

  removeContentPreviewStatus(){
    if(!this.playableHasContentPreview()) return;

    let element = this.playerElement();
    element.setAttribute("data-has-content-preview", "false");
  }

  setPlayerStatus(type) {
    const headers = window.watchHe != undefined ? { 'X-Watch-He' : window.watchHe } : {};

    $.ajax({
      url: `/interactions_stream.json?video_id=${this.playableId}&type=${type}`,
      dataType: 'json',
      headers: headers,
      method: 'GET'
    }).done(function(data) {
      this.onInteractionStreamSuccess(type, data);
    }.bind(this)).fail(function(err){
      this.onInteractionStreamFailed(parseInt(err.status), err.responseJSON, type);
    }.bind(this));
  }

  onInteractionStreamSuccess(playableType, data) {
    if (window.player == undefined) {
      Topic.subscribeOnce('player/ready', this.setNewSource.bind(this, data));
    } else {
      this.setNewSource(data);
    }

    this.initComponentInitializer();

    this.applyContentEligibility(data);

    this.initWatchAccess(playableType, data);
  }

  typeChopping(value) {
    if (value === 'videos') return 'video';
    if (value === 'livestreamings') return 'livestreaming';
    return value;
  }

  onInteractionStreamFailed(statusCode, responseJSON, type) {
    var errorCode = 0;
    if(responseJSON){
      errorCode = responseJSON.error_code;
    }
    if(statusCode == 403) {
      if (errorCode == 10030006) {
        var errorMessage = ''
        var detailButtonMessage = ''
        if( responseJSON && responseJSON.error_message && responseJSON.detail_error_button_message ) {
          errorMessage = responseJSON.error_message;
          detailButtonMessage = responseJSON.detail_error_button_message;
        }
        this.showWatchLimiterBlocker(type, errorMessage,detailButtonMessage);
      } else {
        this.showWatchLimiterBlocker(type, '', '');
      }
    }
  }

  showWatchLimiterBlocker(type, errorMessage, detailButtonMessage ) {
    WatchSessionLimiter.showBanner(errorMessage, detailButtonMessage);
    AhoyEvent.send('PLAYBACK::BLOCKER', {
      content_type: this.typeChopping(type),
      is_premier: KmklabsUtil.isPremium(),
      content_id: this.playableId,
      blocker_type: 'limitwatch',
    });
  }

  initWatchAccess(playableType, data) {
    if(data.single_watch_session == true){
      WatchSessionLimiter.startHeartbeat(this.playableId, playableType);
    }

    if(data.periodic_content_access_check) {
      ContentAccessWatcher.watch(this.playableId, playableType);
    }
  }

  playerOfferElement(){
    let playerOffer = document.querySelector('.livestreaming-ticket');
    if(!playerOffer) {
      playerOffer = document.querySelector('.player-offer');
    }
    return playerOffer;
  }

  toggleBannerOrCta(data){
    let premierCta = this.playerOfferElement();
    if(premierCta) {
      premierCta.classList.remove('hide');
      this.initBannerPackageOfferInfo();
      AhoyEvent.send('VIDIO::SUBSCRIPTION', {
        action: 'impression',
        single_purchase: premierCta.dataset.singlePurchase == 'true' ? true : false,
        content_id: parseInt(premierCta.dataset.liveId),
        feature: premierCta.dataset.feature
      });
      let offerDesc = document.querySelector('.player-offer-desc.js-ahoy');
      if(offerDesc) {
        new AhoyTracker(offerDesc).sendEventImpression();
      }
    } else {
      if(isMobile()){
        SubscriptionBanner.show(data);
      }
      CommentVideoSection.disable();

      Topic.publish('livestreaming/playeroffer/show', { mismatch: IsPremiumUser.get() });
      Topic.subscribe('livestreaming/playeroffer/topicsubscribed', () => {
        Topic.publish('livestreaming/playeroffer/show', { mismatch: IsPremiumUser.get() });
      });
    }
  }

  initBannerPackageOfferInfo() {
    if(IsPremiumUser.get()) {
      let notSubscribedPackageInfo = document.querySelector('.js-player-offer-not-subscribe-package');
      let mismatchPackageInfo = document.querySelector('.js-player-offer-mismatch-package');

      if (notSubscribedPackageInfo && mismatchPackageInfo) {
        notSubscribedPackageInfo.classList.add('hide');
        mismatchPackageInfo.classList.remove('hide');
      }

    }
  }

  showPlayerOffer() {
    let playerOffer = this.playerOfferElement();

    if(playerOffer) {
      playerOffer.classList.remove('hide');
    }
  }

  showPlayerThumbnail() {
    const playerThumbnail = document.querySelector('.player-thumbnail-blocker')

    if(playerThumbnail){
      playerThumbnail.classList.remove('hide')
    }
  }

  showLinkToTicket() {
    let playerOffer = this.playerOfferElement();
    let subsOffer = document.querySelector('.player-offer-subscription'); 
    let ticketLink = document.querySelector('.player-offer-ticket'); 

    if(playerOffer && subsOffer && ticketLink) {
      subsOffer.classList.add('hide');
      ticketLink.classList.remove('hide');
      
      if(!this.contentTypeIsVideos()){
        playerOffer.classList.remove('hide');
      }
    }

    Topic.publish('livestreaming/playeroffer/show', { subscribed: true });
    Topic.subscribe('livestreaming/playeroffer/topicsubscribed', () => {
      Topic.publish('livestreaming/playeroffer/show', { subscribed: true });
    });
  }

  getVoucherCodeParam() {
    const urlParam = new URLSearchParams(this.locationAdapter.search);
    return urlParam.get('voucher_code');
  }

  applyVoucher() {
    const voucherCodeURLParam = this.getVoucherCodeParam();

    if(voucherCodeURLParam) {
      ApiKey.getApiKey().then(() => {
        new VoucherActivation().activate(voucherCodeURLParam);
      });
    }
  }

  applyContentEligibility(data){
    switch(this.getContentEligibility(data)) {
      case PremiumPlayerInitializer.EligibleForFullContent:
        SubscriptionBanner.hide();
        this.showLinkToTicket();
        return;

      case PremiumPlayerInitializer.EligibleForVideoPreview:
        SubscriptionBanner.hide();
        CommentVideoSection.disable();
        if(!isMobile()){
          this.toggleBannerOrCta();
        }
        break;

      case PremiumPlayerInitializer.EligibleForLivestreamingPreview:
        SubscriptionBanner.hide();
        if(this.isUpcomingLivestreaming()) {
          this.applyVoucher();
          this.toggleBannerOrCta(data);
        }
        break;

      case PremiumPlayerInitializer.NotEligibleForContent:
        if(data.source === null) return;
        this.hideLoader();
        CommentVideoSection.disable();
        this.applyVoucher();
        this.toggleBannerOrCta();
        this.showPlayerThumbnail()
    }
  }

  getContentEligibility(data) {
    let { source, is_preview: isPreview } = data;

    // Content is full content or livestreaming content preview (source is true or a string)
    if(source) {

      // Content is livestreaming content preview
      if(isPreview) {
        return PremiumPlayerInitializer.EligibleForLivestreamingPreview;
      }

      // Content can be fully watched
      return PremiumPlayerInitializer.EligibleForFullContent;

    // Content is video content preview
    } else if(source == false && this.playableHasContentPreview()) {
      return PremiumPlayerInitializer.EligibleForVideoPreview;

    // Content is not playable
    } else {
      return PremiumPlayerInitializer.NotEligibleForContent;
    }
  }

  isUpcomingLivestreaming() {
    let playerOffer = document.querySelector('.player-offer[data-feature="upcoming"]');
    return !!playerOffer;
  }

  initComponentInitializer() {
    new ComponentInitializers();
  }

  get type() {
    if(this._type == undefined) {
      let type = document.querySelector('body').getAttribute('data-controller').includes('videos');
      this.type = type ? 'videos' : 'livestreamings';
    }
    return this.type;
  }

  get currentUser() {
    return isEmptyObject(this._currentUser) ? null : this._currentUser;
  }

  get playableId(){
    if(this._playableId != null){
      return this._playableId;
    }

    this._playableId = KmklabsUtil.videoId();
    return this._playableId;
  }
}
